import { render, staticRenderFns } from "./MigrarHistorico.vue?vue&type=template&id=00d6d454"
import script from "./MigrarHistorico.vue?vue&type=script&lang=ts"
export * from "./MigrarHistorico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports